var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Block",
    class: {
      'Block--withoutPadding': _vm.withoutPadding
    },
    on: {
      "blur": _vm.blurEvent,
      "focus": function ($event) {
        _vm.hovered = true;
      },
      "mouseleave": _vm.blurEvent,
      "mouseover": function ($event) {
        _vm.hovered = true;
      }
    }
  }, [_c('transition', {
    attrs: {
      "mode": "out-in",
      "name": "translateY"
    }
  }, [_vm.displayActionsButton ? _c('actions-button', {
    staticClass: "Block-actionsButton",
    attrs: {
      "color": '#573781',
      "containerId": _vm.containerId,
      "forceHideDropdown": _vm.getForceHideDropdown,
      "keepScroll": _vm.keepScroll
    }
  }, [_c('ul', {
    staticClass: "ActionsButton-actions",
    attrs: {
      "id": 'js-dropdown-animated'
    }
  }, _vm._l(_vm.menuOptions, function (option, index) {
    return _c('li', {
      key: ("block_option_" + index),
      staticClass: "ActionsButton-action",
      class: ("Block-action--" + (option.type)),
      on: {
        "click": option.method,
        "keyup": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return option.method.apply(null, arguments);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          return option.method.apply(null, arguments);
        }]
      }
    }, [option.icon ? _c('span', {
      staticClass: "Block-icon",
      class: option.icon
    }) : _vm._e(), _vm._v(" " + _vm._s(option.label) + " ")]);
  }), 0)]) : _vm._e()], 1), _vm.title ? _c('h1', {
    staticClass: "Block-title",
    class: {
      'Block-title--withActionButton': _vm.displayActionsButton
    },
    attrs: {
      "aria-label": _vm.title,
      "tabindex": _vm.globalTabIndex
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " "), _vm.titleInfos ? _c('span', {
    staticClass: "Block-title Block-title--light"
  }, [_vm._v(_vm._s(_vm.titleInfos))]) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "Block-content",
    class: {
      'Block-content--fullHeight': _vm.title === '',
      'Block-content--centered': _vm.contentCentered,
      'Block-content--withoutPadding': _vm.withoutPadding
    }
  }, [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }